<template>
    <div>
        <CModal
            add-content-classes="border-radius-1"
            :show.sync="isDialog"
            color="danger"
            :centered="true"
            :close-on-backdrop="false"
        >
          <template #header-wrapper>
            <div >

            </div>
          </template>
          <template #body-wrapper>
            <CCard class="bg-style2">
              <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
                <span  class="font-weight-bold h6"><CIcon name="cil-speech" size="lg"/> Create Admin </span>

              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol>{{ $t('staffID') }} : {{ object.code }}</CCol>
                </CRow>
                <CRow>
                  <CCol> {{ object.info }}</CCol>
                </CRow>
                <CRow>
                  <CCol> {{ object.agency }}</CCol>
                </CRow>



                <CDropdownDivider class="mt-3"/>
                <CRow class="text-right mt-3">
                  <CCol col="12" class="text-right">
                    <CButton class="mr-2" v-c-tooltip.hover.click="'SEND'" size="sm" color="danger" shape="pill" variant="outline" @click="onDismiss"  >
                      <CIcon name="cil-ban"/> <samp class=" mr-1">CLOSE</samp>
                    </CButton>
                    <CButton  v-c-tooltip.hover.click="'SEND'" size="sm" color="info" shape="pill" variant="outline" @click="onSave"  >
                      <CIcon name="cil-save"/> <samp class=" mr-1">SAVE</samp>
                    </CButton>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </template>
          <template #footer-wrapper>
            <div>

            </div>
          </template>
        </CModal>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
      name: 'DCreateAdmin',
      props: {
        icon: {
          type: String,
          default: 'cil-user'
        },
        isDialog: {
          type: Boolean,
          default: false
        },
        object: {
          type: Object,
          default: {}
        }
      },
        data: function () {
            return {

            }
        },
        mounted() {

        },

        created() {
        },

        beforeDestroy() {

        },

        methods: {
          onDismiss(){
            // this.isDialog = false
            this.$emit("dismiss", false)
          },

          onSave(){
            this.$emit("save",this.object)
          }
        },

        computed: {
            ...mapGetters({
              lang: "setting/lang",
            })
        },

        watch: {
        }
    }
</script>

<style>
</style>
